import { request } from '@tencent/ppd-base-libs';
import { ConfigParams, GrayConfig } from './type';

/** 灰度配置链接前缀，例如业务是 balance, 则完整链接是 https://st.moneydata.hk/res/cc/grayRelease/balance.json  */
const GRAY_CONFIG_URL_PREFIX = 'https://st.moneydata.hk/res/cc/grayRelease';

/** 默认获取业务 */
const requestConfig = (business: string) => request.loadVtools(`${GRAY_CONFIG_URL_PREFIX}/${business}.json`);

// TODO: 后续使用 wphk-base-utils 中的单例 promise 方法
let configPromise: Promise<GrayConfig>;

/**
 * 获取灰度逻辑配置，链接为默认地址加上业务类型
 * @param params
 * @returns
 */
export const getConfig = (params: ConfigParams): Promise<GrayConfig> => {
  if (configPromise !== undefined) {
    return configPromise;
  }
  const { business, getConfig = requestConfig } = params;
  configPromise = getConfig(business);
  return configPromise;
};

/**
 * 获取灰度配置，支持多个时间段的灰度配置，即灰度放量
 * @param config 获取的灰度配置数组
 * @param name 灰度名称，若未传入灰度名称，则默认使用配置中的第一份，这种情况代表一个业务只有一份配置。
 * @returns
 */
export const filterConfigs = (config: GrayConfig, name?: string) => {
  // 若未传入灰度名称，则默认使用配置中的第一份，这种情况代表一个业务只有一份配置。
  if (!name) {
    return config[0];
  }
  const currentConfig = config.filter(item => item.name === name);
  const nowDate = new Date();
  return currentConfig.find((item) => {
    // 若没有设置startTime, 则认为命中该配置
    if (!item.startTime) {
      return true;
    }
    const startTime = new Date(item.startTime);
    // 检查开始时间小于目前时间，则继续检查其他情况
    if (startTime <= nowDate) {
      // 若未设置结束时间，且开始时间小于目前时间，认为命中该配置
      if (!item.endTime) {
        return true;
      }
      const endTime = new Date(item.endTime);
      // 若结束时间大于当前时间，则认为命中该配置
      return endTime >= nowDate;
    }
    return false;
  });
};
